// Abhinashdeep Singh 8907518
import React from "react";

const ContactHeader = () => {
    return (
        <div className="contact-banner">
            <h1 className="contact-header">Contact Us</h1>
            <p className="contact-sub-header">How can we help you?</p>
        </div>
    );
};

export default ContactHeader;